import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const AIQueryInterface = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        AI Sorgu Arayüzü
      </Typography>
      <Paper sx={{ p: 2 }}>
        <Typography>Doğal dil sorgu arayüzü burada görüntülenecek</Typography>
      </Paper>
    </Box>
  );
};

export default AIQueryInterface;
